import { reflectKeys } from "@utils/key.reflactor";

export const ACHIEVEMENT_BATCH = {
  HOLDING_PERIOD: 2000, //milliseconds
  BATCH_SIZE: 5,
};

export const CHECK_ACHIEVEMENT_STATUS = reflectKeys(["OFF", "LOADING", "COMPLETE"]);

export const MODIFIERS = reflectKeys([
  "EARLY_LATE_MODIFIER",
  "OPEN_HINT_MODIFIER",
  "QUESTION_RETRY_MODIFIER",
  "EXCEED_QUIZ_TIME_MODIFIER",
  "QUIZ_RETRY_MODIFIER",
]);

export const MODIFIER_TOAST = {
  EARLY_MODIFIER: {
    message: "gamification_xp_early_modifier",
    typeKey: "early",
  },
  LATE_MODIFIER: {
    message: "gamification_xp_late_modifier",
    typeKey: "late",
  },
  OPEN_HINT_MODIFIER: {
    message: "gamification_xp_open_hint_modifier",
    typeKey: "open-hint",
  },
  QUESTION_RETRY_MODIFIER: {
    message: "gamification_xp_question_retry_modifier",
    typeKey: "question-retry",
  },
  EXCEED_QUIZ_TIME_MODIFIER: {
    message: "gamification_xp_exceed_quiz_time_modifier",
    typeKey: "exceed-quiz-time",
  },
  QUIZ_RETRY_MODIFIER: {
    message: "gamification_xp_quiz_retry_modifier",
    typeKey: "quiz-retry",
  },
};

export const QUIZ_STREAK_TOAST = {
  STREAK_COUNT: {
    message: "gamification_xp_streak_count_modifier",
    subMessageTemplate: "gamification_xp_streak_count_message_",
    restartIndex: 2,
    maxSubMessageIndex: 20,
    typeKey: "streak",
  },
  MAX_STREAK: {
    message: "gamification_xp_max_streak_toast_message",
    typeKey: "streak",
  },
  DEFAULT_MIN_STREAK_DISPLAY: 2,
};
export const DEFAULT_GAMIFICATION_TOAST_DELAY_MS = 500;

export const GAME_AWARD_TYPE = {
  GAME_STORY: "GAME_STORY",
  COLLECTIBLE: "COLLECTIBLE",
  ACHIEVEMENT: "ACHIEVEMENT",
  GAME_AVATAR: "GAME_AVATAR",
  DIGITAL_BADGE: "DIGITAL_BADGE",
};
